import { getToken } from "../utils/authHelpers";
import { request } from "../utils/requestHelpers";
import DocumentSerializer from "../serializers/DocumentSerializer";

export default class ImageRepository {
  IMAGES_BASE = "/api/images";
  IMAGE_BASE = "/api/image";

  constructor() {
    this.headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer"
    };
  }

  async getDocumentsTypes(instance, params) {
    const token = await getToken(instance);
    const path = `${this.IMAGES_BASE}/document/types?${params}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    return Promise.resolve(req.documentTypes);
  }

  async getDocument(instance, id, params) {
    const token = await getToken(instance);
    const path = `${this.IMAGES_BASE}/${id}?${params}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    }, false, true);

    return Promise.resolve(req);
  }

  async getDocuments(instance, params) {
    const token = await getToken(instance);
    const path = `${this.IMAGES_BASE}?${params}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    return Promise.resolve(
      req.imageDocuments.map(carrier => (DocumentSerializer.deSerialize(
        carrier
      ))));
  }

  async uploadDocument(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.IMAGE_BASE}/storeDocument`;

    const req = await request(path, {
      method: "POST",
      headers:
      {
        Authorization: `Bearer ${token}`,
      },
      body: payload
    });

    return Promise.resolve(req);
  }
}